import ReactDOM from "react-dom"

export const dispatchCustomEvent = (element, eventName, data) => {
  // If element is null, dispatch on document or window
  let targetElement = element || document;
  // ugh, internet explorer is so dumb:
  // https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way

  let event = document.createEvent('CustomEvent');
  event.initCustomEvent(eventName, true, true, data);
  console.log("Dispatching event", eventName, "on element", targetElement, "with data", data);
  targetElement.dispatchEvent(event);
}
